import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandAddprestartPage } from '../cabsand-addprestart/cabsand-addprestart';

@IonicPage()
@Component({
  selector: 'page-cabsand-prestart',
  templateUrl: 'cabsand-prestart.html',
})
export class CabsandPrestartPage {
  prestartList: any = [];
  appColor:String;
  filePathUrl:String;
  actionAllowed:boolean = false;

  currentPage = 1;
  totalPage = 0;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getappColor();
    this.getprestartList();

  }

  async getappColor(){
    this.appColor = await this.utiltiy.getStorage("primaryColor");
  }

  previousPage(){
    this.currentPage--;
    this.getprestartList();
  }
  nextPage(){
    this.currentPage++;
    this.getprestartList();

  }


  getprestartList() {
    this.prestartList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "read_list");
    formData.append("page", this.currentPage.toString());
    this.api.post("/tansix_prestart/Tansix_prestart_get",false,formData)
      .then((result: any) => {
        console.log("result", result)
        this.prestartList = result.result;
        this.filePathUrl = result.file_uploaded_path;
        if(result.pagination){
          this.totalPage = result.pagination.total_pages;
        }
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async getPrestartDetail(id){
    this.utiltiy.startLoading();
    return this.api.get("/tansix_prestart/Tansix_prestart_get?method_name=get_edit_list&id="+id, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if(result.status){
          return result.result[0];
        }else{
          return false;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return false;
      })
  }

  checkStatus(string) {
    return string.includes("Faulty");
  }

  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deletePrestart(id);
    }
    console.log("status", status);
  }


  deletePrestart(id) {
    this.api.delete(`/tansix_prestart/delete/${id}`, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.getprestartList();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }
 addPrestart(){
   this.navCtrl.push(CabsandAddprestartPage, { param: null });
 }
 async updatePrestart(prestart){
  let detail = await this.getPrestartDetail(prestart.id);
  console.log("detail",detail)
  if(detail){
    detail.file_uploaded_path = this.filePathUrl;
    this.navCtrl.push(CabsandAddprestartPage, { param: detail });
  }
 }
 preViewPrestart(prestart){
  // prestart.file_uploaded_path = this.filePathUrl;
  prestart.file_uploaded_path = this.filePathUrl;

  prestart.disableField = true;
   this.navCtrl.push(CabsandAddprestartPage, { param: prestart });
 }

 async getPermission(){
  this.actionAllowed =  await this.utiltiy.getPagePermission("cabsand-prestart-rw");
 }

}



// WEBPACK FOOTER //
// ./src/pages/cabsand-prestart/cabsand-prestart.ts